import React, {useState, useEffect} from 'react'
import RichTextEditor from '../../pb_rich_text_editor/_rich_text_editor'
import { useEditor, EditorContent } from "@tiptap/react"
import StarterKit from "@tiptap/starter-kit"

import Select from '../../pb_select/_select'

const release = `
  <div>
    <div>
      <strong>Story Background</strong>
    </div>
    <div>
      Follow the{" "}
      <a href='https://github.com/powerhome/playbook/wiki/Release-Team-Guide'>
        release process
      </a>{" "}
      to create a new version, create a gem, and package. Create a Ninja testing
      plan, then update Nitro with the new version.
    </div>
    <div>
      <br />
    </div>
    <div>
      <strong>Timeline / Due Date</strong>
    </div>
    <div>
      <em>Release End of business Thursday</em>
    </div>
    <div>
      <em>Testing on Nitro End of business Friday</em>
    </div>
    <div>
      <br />
    </div>
    <div>
      <strong>Definition of done</strong>
    </div>
    <ol>
      <li>Merge all PR’s</li>
      <li>Update the final CHANGELOG</li>
      <li>Version up and generate NPM, and RubyGem</li>
      <li>Create next version branch and milestone</li>
      <li>Update default branch and branch protection rules&nbsp;</li>
      <li>Notify Everyone of new version</li>
      <li>
        Generate testing plan and pages to test for Ninjas (update runway
        ticket)
      </li>
      <li>Update version on Nitro and get on Demo</li>
      <li>Send Ninjas demo and runway ticket for testing</li>
      <li>Ninja Approved + PR Approved</li>
    </ol>
    <div>
      <br />
    </div>
    <div>
      <strong>Stakeholders / Sign-off</strong>
    </div>
    <ul>
      <li>Code Owners</li>
    </ul>
    <div>
      <br />
      <strong>Cadence</strong>
      <br />
      Jason, Jon, Stephen, Jasper, Brendan, Cole
    </div>
  </div>
`

const changelog = `
  <div>
    <strong>Changelog:<br></strong>
    [INSERT LINK]<br><br>
    You can test the normal spots of Playbook rails and react on
    dev docs plus the following:
  </div>
  <div>
    <br>
  </div>
`

const RichTextEditorAdvancedTemplates = (props) => {

const [editorContent, setEditorContent] = useState('')
    
const handleChange = (event) => {
        setEditorContent(event.target.value)
}
  const templatesOptions = [
    {
      value: release,
      text: 'Playbook Release',
    },
    {
      value: changelog,
      text: 'Changelog',
    },
  ]

    const editor = useEditor({
        extensions: [StarterKit.configure({ trailingNode: false })],
        content: editorContent
    })

    // Update editor content when editorContent state changes
    useEffect(() => {
        if (editor && editorContent) {
            editor.commands.setContent(editorContent)
        }
    }, [editor, editorContent])

      if (!editor) {
        return null
      } 

      


  return (
    <div>
        <Select
            blankSelection="Select a template..."
            label="Template"
            onChange={handleChange}
            options={templatesOptions}
            {...props}
        />
        <RichTextEditor
            advancedEditor={editor}
            {...props}
        >
        <EditorContent editor={editor}/>
        </RichTextEditor>
    </div>
  )
}

export default RichTextEditorAdvancedTemplates